// class FvSizeChange {
// 	constructor() {

// 	}
// }

class KvSlider {
  constructor() {
    this.bindAll();

    this.vert = `
    varying vec2 vUv;
    
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
    `;

    this.frag = `
    varying vec2 vUv;

    uniform sampler2D texture1;
    uniform sampler2D texture2;
    uniform sampler2D disp;

    uniform float dispPower;
    uniform float intensity;

    uniform vec2 size;
    uniform vec2 res;
    uniform vec2 resolution;
    uniform vec2 imageResolution;

    vec2 backgroundCoverUv( vec2 screenSize, vec2 imageSize, vec2 uv ) {
      float screenRatio = screenSize.x / screenSize.y;
      float imageRatio = imageSize.x / imageSize.y;
      vec2 newSize = screenRatio < imageRatio 
          ? vec2(imageSize.x * (screenSize.y / imageSize.y), screenSize.y)
          : vec2(screenSize.x, imageSize.y * (screenSize.x / imageSize.x));
      vec2 newOffset = (screenRatio < imageRatio 
          ? vec2((newSize.x - screenSize.x) / 2.0, 0.0) 
          : vec2(0.0, (newSize.y - screenSize.y) / 2.0)) / newSize;
      return uv * screenSize / newSize + newOffset;
    }

    void main() {
      vec2 ratio = vec2(
          min((resolution.x / resolution.y) / (imageResolution.x / imageResolution.y), 1.0),
          min((resolution.y / resolution.x) / (imageResolution.y / imageResolution.x), 1.0)
        );
        vec2 uv = vec2(
            vUv.x * ratio.x + (1.0 - ratio.x) * 0.5,
            vUv.y * ratio.y + (1.0 - ratio.y) * 0.5
          );
      
      vec4 disp = texture2D(disp, uv);
      vec2 dispVec = vec2(disp.x, disp.y);
      
      vec2 distPos1 = vec2(uv.x + dispPower * (disp.r*intensity), uv.y);
      vec2 distPos2 = vec2(uv.x - ((1.0 - dispPower) * (disp.r*intensity)), uv.y);
      
      vec4 _texture1 = texture2D(texture1, distPos1);
      vec4 _texture2 = texture2D(texture2, distPos2);
      
      gl_FragColor = mix(_texture1, _texture2, dispPower);
    }
    `;

    this.el = document.querySelector('.js-slider');
    this.inner = this.el.querySelector('.js-slider__inner');
    this.slides = [...this.el.querySelectorAll('.js-slide')];
    this.bullets = [...this.el.querySelectorAll('.js-slider-bullet')];

    this.renderer = null;
    this.scene = null;
    this.clock = null;
    this.camera = null;

    if (location.hostname === 'watson-test.com') {
      this.images = [
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv1.jpg',
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv2.jpg',
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv3.jpg',
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv4.jpg',
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv5.jpg',
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv6.jpg',
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv7.jpg',
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv8.jpg',
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv9.jpg',
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv10.jpg',
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv11.jpg',
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv12.jpg',
        'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv13.jpg',
      ];
    } else if(location.hostname === 'watsonbiolab.com') {
      this.images = [
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv1.jpg',
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv2.jpg',
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv3.jpg',
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv4.jpg',
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv5.jpg',
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv6.jpg',
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv7.jpg',
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv8.jpg',
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv9.jpg',
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv10.jpg',
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv11.jpg',
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv12.jpg',
        'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv13.jpg',
      ];
    } else {
      this.images = [
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv1.jpg',
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv2.jpg',
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv3.jpg',
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv4.jpg',
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv5.jpg',
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv6.jpg',
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv7.jpg',
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv8.jpg',
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv9.jpg',
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv10.jpg',
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv11.jpg',
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv12.jpg',
        'wp-content/themes/sherlock/template-develop/src/assets/images/top/Kv13.jpg',
      ];
    }

    this.data = {
      current: 0,
      next: 1,
      total: this.images.length - 1,
      delta: 0,
    };

    this.state = {
      animating: false,
      text: false,
      initial: true,
    };

    this.textures = null;

    this.init();
  }

  init() {
    this.setup();
    this.cameraSetup();
    this.loadTextures();
    this.createMesh();
    this.setStyles();
    this.render();
    this.listeners();
    
  }

  bindAll() {
    ['render', 'nextSlide'].forEach((fn) => (this[fn] = this[fn].bind(this)));
  }

  setStyles() {
    this.slides.forEach((slide, index) => {
      if (index === 0) return;

      gsap.set(slide, { autoAlpha: 0 });
    });

    this.bullets.forEach((bullet, index) => {
      if (index === 0) return;

      const line = bullet.querySelector('.js-slider-bullet__line');

      gsap.set(line, {
        scaleX: 0,
      });
    });
  }

  cameraSetup() {
    this.camera = new THREE.OrthographicCamera(
      this.el.offsetWidth / -2,
      this.el.offsetWidth / 2,
      this.el.offsetHeight / 2,
      this.el.offsetHeight / -2,
      1,
      1000,
    );

    this.camera.lookAt(this.scene.position);
    this.camera.position.z = 1;
  }

  setup() {
    this.scene = new THREE.Scene();
    this.clock = new THREE.Clock(true);

    this.renderer = new THREE.WebGLRenderer({ alpha: true });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.el.offsetWidth, this.el.offsetHeight);

    this.inner.appendChild(this.renderer.domElement);
  }

  loadTextures() {
    const loader = new THREE.TextureLoader();
    loader.crossOrigin = '';

    this.textures = [];
    this.images.forEach((image, index) => {
      const texture = loader.load(image + '?v=' + Date.now(), this.render);

      texture.minFilter = THREE.LinearFilter;
      texture.generateMipmaps = false;

      if (index === 0 && this.mat) {
        this.mat.uniforms.size.value = [
          texture.image.naturalWidth,
          texture.image.naturalHeight,
        ];
      }

      this.textures.push(texture);
    });

    this.disp = loader.load(
      location.hostname === 'watson-test.com'
      ? 'wp/wp-content/themes/sherlock/template-develop/src/assets/images/top/texture.png'
      : location.hostname === 'watsonbiolab.com'
        ? 'cms/wp-content/themes/sherlock/template-develop/src/assets/images/top/texture.png'
        : 'wp-content/themes/sherlock/template-develop/src/assets/images/top/texture.png',
      this.render,
    );
    this.disp.magFilter = this.disp.minFilter = THREE.LinearFilter;
    this.disp.wrapS = this.disp.wrapT = THREE.RepeatWrapping;
  }

  createMesh() {
    this.mat = new THREE.ShaderMaterial({
      uniforms: {
        dispPower: { type: 'f', value: 0.0 },
        intensity: { type: 'f', value: 0.5 },
        res: {
          value: new THREE.Vector2(window.innerWidth, window.innerHeight),
        },
        size: { value: new THREE.Vector2(1, 1) },
        texture1: { type: 't', value: this.textures[0] },
        texture2: { type: 't', value: this.textures[1] },
        disp: { type: 't', value: this.disp },
        resolution: {
          type: 'v2',
          value: new THREE.Vector2(window.innerWidth, window.innerHeight),
        },
        imageResolution: {
          type: 'v2',
          value: new THREE.Vector2(1366, 768),
        },
      },
      transparent: true,
      vertexShader: this.vert,
      fragmentShader: this.frag,
    });

    const geometry = new THREE.PlaneBufferGeometry(
      this.el.offsetWidth,
      this.el.offsetHeight,
      1,
    );

    const mesh = new THREE.Mesh(geometry, this.mat);

    this.scene.add(mesh);
  }

  transitionNext() {
    gsap.to(this.mat.uniforms.dispPower, 4.5, {
      value: 1,
      ease: 'expo.inOut',
      onUpdate: this.render,
      onComplete: () => {
        this.mat.uniforms.dispPower.value = 0.0;
        this.changeTexture();
        this.render.bind(this);
        this.state.animating = false;
      },
    });

    const currentBullet = this.bullets[this.data.current];
    const nextBullet = this.bullets[this.data.next];

    const currentBulletLine = currentBullet.querySelectorAll(
      '.js-slider-bullet__line',
    );
    const nextBulletLine = nextBullet.querySelectorAll(
      '.js-slider-bullet__line',
    );

    const tl = gsap.timeline({ paused: true });

    tl.to(
      currentBulletLine,
      1.5,
      {
        scaleX: 0,
        ease: 'expo.inOut',
        transformOrigin: 'right',
      },
      0.5,
    );

    tl.to(
      nextBulletLine,
      1.5,
      {
        transformOrigin: 'left',
        scaleX: 1,
        ease: 'expo.inOut',
      },
      1.45,
    );

    tl.play();
  }

  prevSlide() {}

  nextSlide() {
    if (this.state.animating) return;

    this.state.animating = true;

    this.transitionNext();

    this.data.current =
      this.data.current === this.data.total ? 0 : this.data.current + 1;
    this.data.next =
      this.data.current === this.data.total ? 0 : this.data.current + 1;
  }

  changeTexture() {
    this.mat.uniforms.texture1.value = this.textures[this.data.current];
    this.mat.uniforms.texture2.value = this.textures[this.data.next];
  }

  listeners() {
    // window.addEventListener("wheel", this.nextSlide, { passive: true });
    setInterval(this.nextSlide, 2000, { passive: true });
  }

  render() {
    this.renderer.render(this.scene, this.camera);
  }
}

class Fv {
  constructor() {
    this.slider = new KvSlider();
  }
  init() {
    this.slider.init();
  }
}
export default Fv;
